export function getPercentageComparisonValues(
  leftPercentage: number,
  rightPercentage: number,
  middlePercentage?: number,
) {
  const percentageLeft = Math.round(leftPercentage);
  const percentageRight = Math.round(rightPercentage);
  const percentageCentre = middlePercentage ? Math.round(middlePercentage) : 0;

  const values = {
    leftValue: percentageLeft,
    rightValue: percentageRight,
    middleValue: percentageCentre,
  };

  if (percentageLeft + percentageRight + percentageCentre !== 100) {
    const largestShare = Math.max(leftPercentage, rightPercentage);
    const overridePercentage = Math.round(largestShare);

    if (largestShare !== rightPercentage) {
      values.leftValue = overridePercentage;
      values.rightValue = 100 - overridePercentage - values.middleValue;
    } else {
      values.leftValue = 100 - overridePercentage - values.middleValue;
      values.rightValue = overridePercentage;
    }
  }

  return values;
}
